import React, {Component} from 'react';
// import App from "../App";

import './css/main.less'
import './css/login.less';
import {Form, Input, Button, Checkbox, Layout, Spin, message} from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import store from "store";
import NavFooter from "../components/NavFooter";
import AxiosUtil from "../utils/AxiosUtil";

interface IProps {

}
export default class Login extends Component<any,IProps> {
    // constructor(props: any) {
    //     super(props);
    // }
    state = {
        showLoading: false,
    }
    static getPowerMenu = (user_id:string) => {
        const callback = (suc: boolean, d?: any) => {
            if (suc) {
                const menus = d.list;
                store.set('login_power', menus);
                // console.log('login_power: ', menus);
                if (menus && menus.length > 0 && menus[0].page_url && menus[0].page_url !== "") {
                    window.setTimeout(() => {
                        window.location.replace('/#/' + menus[0].page_url)
                    }, 1000)
                } else {
                    window.setTimeout(() => {
                        window.location.replace('/')
                    }, 1000)
                }
            }
        }
        AxiosUtil.AxiosRequest('/api/menu/menuList', {user_id: user_id}, callback);
    }

    render(){
        const onFinish = (values: any) => {
            // console.log('Received values of form: ', values);
            this.setState({showLoading: true});

            const dataBind = (suc: boolean, dat?: any) => {
                if (suc) {
                    store.set('login_info', dat);
                    message.success('登录成功，即将跳转');

                    Login.getPowerMenu(dat.user_id);
                }
                this.setState({showLoading: false});
            }
            const post = {
                login_name: values.login_name,
                login_password: values.login_password
            }
            AxiosUtil.AxiosRequest('/authApi/login/login', post, dataBind);
        };

        var d = new Date();
        store.set("time", d.toString());

        return(

            <div>
                <Layout.Header className={'main-header'}>
                    <div className={'logo'}></div>
                    <div className={'flex-blank'}></div>
                </Layout.Header>
                <div className={'layout-main'}>
                    <div className={'layout-left'}></div>
                    <div className={'layout-right'}>
                        <div className={'login-div'}>
                            <Spin className={'loading-spin'} tip="Loading..." size="large" spinning={this.state.showLoading}  >
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{ remember: true }}
                                onFinish={onFinish}
                            >
                                <Form.Item name="login_name"
                                           rules={[{ required: true, message: '请输入用户名!' }]}
                                           style={{marginBottom: 32}}
                                >
                                    <Input prefix={<UserOutlined className="site-form-item-icon" />}
                                           placeholder="用户名/手机号/邮箱" />
                                </Form.Item>
                                <Form.Item name="login_password"
                                           rules={[{ required: true, message: '请输入您的密码!' }]}
                                           style={{marginBottom: 32}}
                                >
                                    <Input
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        placeholder="密码"
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Form.Item name="remember" valuePropName="checked" noStyle>
                                        <Checkbox>记住我</Checkbox>
                                    </Form.Item>

                                    <a className="login-form-forgot" href="/">
                                        忘记密码
                                    </a>
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="login-form-button" >
                                        登录
                                    </Button>
                                    <a href="/">立即注册!</a>
                                </Form.Item>
                            </Form>
                            </Spin>
                        </div>
                    </div>
                </div>
                <NavFooter/>

            </div>
        );
    }

}
